import { useMutation } from "@apollo/client/react";
import { APPROVE_INVOICES } from "../../mutations/invoices/approveInvoices";
import type { InvoiceOperationResult } from "../../../models/InvoiceAssessment";
import GET_CLIENT_INVOICES from "../../queries/invoices/getClientInvoices";
import GET_CLIENT_ASSESSMENT_INVOICES from "../../queries/invoices/getClientAssessmentInvoices";
import GET_INVOICE_ASSESSMENT_DETAILS from "../../queries/invoices/getInvoiceAssessmentDetails";

export type ApproveInvoicesResult = {
  invoice: { approveInvoices: InvoiceOperationResult[] };
};

export const useApproveInvoices = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: ApproveInvoicesResult) => void;
  onError: (e?: Error) => void;
}) => {
  const [approveInvoices, { data, loading, error }] =
    useMutation<ApproveInvoicesResult>(APPROVE_INVOICES, {
      onCompleted,
      onError,
      refetchQueries: [
        GET_CLIENT_INVOICES,
        GET_CLIENT_ASSESSMENT_INVOICES,
        GET_INVOICE_ASSESSMENT_DETAILS,
      ],
      awaitRefetchQueries: true,
    });

  return { approveInvoices, data, loading, error };
};
